import React from 'react';
import InvoiceTotals from '../iesire/InvoiceTotals';
import { parseNumber } from './formatters';

export default function InputTotals({ lines = [], currency = 'RON' }) {
  // Sum the same rounded amounts displayed in the purchase invoice rows.
  const cents = (lines || []).reduce((sum, line) => ({
    base: sum.base + Math.round(parseNumber(line.bxvamount) * 100),
    vat: sum.vat + Math.round(parseNumber(line.bxvatv_amount) * 100),
    total: sum.total + Math.round(parseNumber(line.bxtotalv_amount) * 100),
  }), { base: 0, vat: 0, total: 0 });
  const amounts = Object.fromEntries(Object.entries(cents).map(([key, value]) => [key, value / 100]));
  return <InvoiceTotals amounts={amounts} currency={currency} />;
}
